import { render, staticRenderFns } from "./PurN_Details.vue?vue&type=template&id=a2117a32"
import script from "./PurN_Details.vue?vue&type=script&lang=js"
export * from "./PurN_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports